import { SurveyVersion } from './SurveyVersion';
import { Question } from './Question';
import { Language } from './Language';
import { SurveyReportType } from './SurveyReportType';
import { HasId } from '../interfaces';

export class SurveyText {
    public id: number;
    public surveyTextType: string;
    public value: string;
    public keyName: string;
    public languageId: number;
    public language: Language;  
    public showModal: boolean;
}

export class Survey implements HasId {
    public id: number;
    public name: string;
    public surveyVersions: SurveyVersion[];
    public questions: Question[];
    public surveyReportTypes: SurveyReportType[];
    public surveyTexts: SurveyText[];

    // demographics
    public collectTitle: boolean;
    public requireTitle: boolean;
    public collectGender: boolean;
    public requireGender: boolean;
    public collectBirthDate: boolean;
    public requireBirthDate: boolean;
    public collectBirthPlace: boolean;
    public requireBirthPlace: boolean;
    public collectEducationLevel: boolean;
    public requireEducationLevel: boolean;
}


// WEBPACK FOOTER //
// ./src/models/Survey.tsx